export default <T>(value?: T[] | T) => {
  if(!value) return undefined;
  return value instanceof Array ? value : [value];
};
